<template>
  <!-- Banner start -->
  <div class="d-flex-partner-banner mb-3">
    <img class="card-img-top border p-2 rounded listing-logo" :src="partner.logo_url" :alt="partner.name + ' Logo'">
    <div class="ms-3 partner-title-wrapper">
      <h4 class="modal-title" id="partnerModalTitle"><b>{{partner.name}}</b></h4>
      <p class="partner-page-tagline">{{partner.rte_tagline}}</p>
      <span class="partner-page-tagline">
      <CallToActions :partner="partner" @open-lead="openLead" @track-action="trackAction" /></span>
    </div>
  </div>
  <!-- Banner end -->
</template>

<script>
import CallToActions from './../listing/CallToActions.vue'
export default {
  props: {
    partner: {
      type: Object,
      default: {}
    },
  },
  components: {
    CallToActions,
  },
  emits: ['openLead', 'trackAction'],
  setup(props, ctx) {
    async function openLead(){
      ctx.emit('openLead')
      ctx.emit('trackAction')
    }
    return {
      openLead
    }
  },
}
</script>
